interface Props {
  title: string
}

export const SummaryTitle: React.FC<Props> = ({ title }) => {
  return (
    <div className="my-[10px] mx-auto w-[250px] text-[15px] font-light">
      {title}
    </div>
  )
}
